import auth from '@/auth/authService';

function logout() {
  auth.logOut();
}

export function getToken() {
  const token = auth.getToken();
  if (!token) {
    logout();
    return false;
  }
  return token;
}
